<template>
    <div>
        <ModelString class="sending-popup__input" label="Название темы" v-model="formData.templateTheme" />
        <ModelFile label="Выбрать файл" v-model="formData.file" @read-attached-file="setFileContent" />
    </div>
</template>

<script>
import ModelString from "@/components/UI/models/ModelString.vue";
import {isEmpty} from "@/tools/filters";
import debounce from '@/tools/debounce';
import ModelFile from "@/components/UI/models/ModelFile.vue";

export default {
    name: "UserSearchNotificationEmailReady",

    components: {ModelFile, ModelString},

    emits: ["update-data", 'update-valid'],

    props: {},

    data: () => ({
        formData: {
            templateTheme: '',
            file: null,
            content: null,
        },
    }),

    beforeMount() {
        this.$set(this.formData, 'templateTheme', '');
        this.$set(this.formData, 'file', null);
        this.$set(this.formData, 'content', null);
    },

    watch: {
        'formData.file'(file) {
            if (!file) {
                this.$set(this.formData, 'content', null);
            }
        },

        formData: {
            handler(newVal) {
                debounce(() => {
                    this.$emit("update-data", newVal);
                    this.$emit(
                        "update-valid",
                        !isEmpty(newVal.templateTheme) && !isEmpty(newVal.content) && !isEmpty(newVal.file),
                    );
                }, 10, false, 'user-search-notification-email-ready')();
            },
            deep: true,
        },
    },

    methods: {
        setFileContent(content) {
            this.$set(this.formData, 'content', content);
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

</style>
